import { render, staticRenderFns } from "./communicationDetailDialog.vue?vue&type=template&id=3942dc56&scoped=true"
import script from "./communicationDetailDialog.vue?vue&type=script&lang=js"
export * from "./communicationDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./communicationDetailDialog.vue?vue&type=style&index=0&id=3942dc56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3942dc56",
  null
  
)

export default component.exports